<template>
  <div class="assessment-border">
    <h1 class>Ask Your Teacher for Help!</h1>
    <div class="assessment-info">
      <p>
        <span>Teacher:</span>The child has run into some trouble completing the activity. Please
        type your initials below and select whether to:
      </p>

      <input
        aria-label="Teacher initials"
        type="text"
        id="inputfield"
        class="initials-textfield"
        ref="inputfield"
        :value="initials"
        v-on:input="updateValue($event.target.value)"
      />
      <p class="input-note">(Minimum 2 characters)</p>
      <div class="assessment-choices">
        <div class="assessment-choice">
          <button
            :disabled="initialsEntered === false"
            v-on:click.prevent="teacherDirection('quit')"
          >
            SKIP
          </button>
          <p>This activity is too advanced for my student.</p>
        </div>
        <div class="assessment-choice">
          <button
            :disabled="initialsEntered === false"
            v-on:click.prevent="teacherDirection('retry')"
          >
            RETRY
          </button>
          <p>This activity is appropriate for my student and I am letting the student retry.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const activity = createNamespacedHelpers('activity');
const keyboard = createNamespacedHelpers('keyboard');
const typingActivity = createNamespacedHelpers('activity/typing');
const application = createNamespacedHelpers('application');

export default {
  data() {
    return {
      initials: ''
    };
  },

  mounted() {
    const initialsInput = document.getElementById('inputfield');

    if (this.usingExternalKeyboard) {
      document.getElementById('external-key-input').style.display = 'none';
    }

    initialsInput.focus();
  },

  computed: {
    ...application.mapState({
      usingExternalKeyboard: state => Boolean(state.device.usingExternalKeyboard)
    }),
    ...activity.mapState({
      activityLink: state => `/activities/${state.data.type}`
    }),
    initialsEntered() {
      return this.initials.length > 1;
    }
  },
  /* eslint-disable*/
  methods: {
    ...activity.mapActions(['restartActivity']),
    ...activity.mapMutations(['setTeacherAction']),
    ...typingActivity.mapMutations(['resetAttemptedKey']),
    ...keyboard.mapMutations(['hideKeyboard', 'releaseHoldKey']),

    updateValue(val) {
      if (!val) return '';
      // eslint-disable-next-line no-param-reassign
      val = val.toString();
      this.initials = val.charAt(0).toUpperCase() + val.slice(1);
    },

    teacherDirection(action) {
      this.setTeacherAction({
        teacherAssist: this.initials,
        teacherAction: action
      });

      if (this.usingExternalKeyboard) {
        const externalKeyboard = document.getElementById('external-key-input');

        externalKeyboard.style.display = 'block';
        externalKeyboard.focus();
      }

      if (action === 'retry') {
        this.restartActivity();
        this.$router.replace({ path: '/curriculum', params: {} });
      } else {
        this.$router.replace({ path: '/activity-trophy', params: {} });
      }
    }
  }
};
</script>

<style lang="scss">
.assessment-border {
  box-sizing: border-box;
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
  border: 3px solid black;
  border-radius: 5px;
  text-align: center;
  width: 960px;
  height: 700px;
  top: 34px;
  position: absolute;
  left: 32px;
  h1 {
    border-bottom: 3px solid black;
    margin: 0;
    padding: 0;
    font-family: 'hwtfutura-bold';
    height: 120px;
    line-height: 120px;
    font-size: 48px;
  }
  .assessment-info {
    padding: 20px 0 0 0;
    width: 750px;
    margin: 0 auto;
    p {
      color: black;
      font-family: 'hwtfutura-semibold';
      padding: 10px;
      font-size: 24px;
      span {
        color: black;
        display: block;
      }
    }
    input[type='text'] {
      box-shadow: inset 2px 2px 10px rgba(0.5, 0.5, 0.5, 0.5);
      margin: 20px auto 0;
      width: 200px;
      height: 90px;
      text-transform: uppercase;
    }
    p.input-note {
      font-size: 14px;
      color: black;
    }
    .assessment-choices {
      margin-top: 24px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: center;
      .assessment-choice {
        width: 400px;
        padding: 0 50px;
        p {
          font-size: 18px;
        }
      }
      button {
        background-color: #009933;
        border: 2px solid black;
        font-family: 'hwtfutura-bold';
        color: white;
        text-transform: uppercase;
        width: 200px;
        height: 65px;
        font-size: 30px;
        margin: 10px 0;
        padding: 0;
        line-height: 65px;
        border-radius: 5px;
        &:disabled {
          background-color: #cccccc;
          color: gray;
          border-color: gray;
        }
      }
    }
  }
}
</style>
